import React, { FC } from "react";
import { Params, Route, Routes } from "react-router-dom";
import { observer } from "mobx-react";
import OrdersGrid from "./OrdersGrid";
import OrderDetailMain from "./OrderDetailMain";
import { Loader, withRouter } from "@mindmemobile/mm-shared-global";
import { ItemsStore, OrderStore, RolesAndPermissionStore } from "../../../shared/store";
import { MerchantAccountStore } from "../../../modules/merchantAccounts";

type IProps = {
  params: Readonly<Params<string>>;
  orderStore: OrderStore;
  itemStore: ItemsStore;
  merchantAccountStore: MerchantAccountStore;
  rolesAndPermissionStore: RolesAndPermissionStore;
};

const OrderRoutes: FC<IProps> = ({
  orderStore,
  itemStore,
  merchantAccountStore,
  rolesAndPermissionStore
}) => {
  if (!itemStore.countryStore.countryDataLoaded) {
    return <>{new Loader().loaderComponent}</>;
  }
  return (
    <Routes>
      <Route
        path="/"
        element={
          <OrdersGrid
            itemStore={itemStore}
            orderStore={orderStore}
            merchantAccountStore={merchantAccountStore}
          />
        }
      />
      <Route
        path={`/detail/:id`}
        element={
          <OrderDetailMain
            itemStore={itemStore}
            orderStore={orderStore}
            rolesAndPermissionStore={rolesAndPermissionStore}
            merchantAccountStore={merchantAccountStore}
          />
        }
      />
    </Routes>
  );
};
export default withRouter(observer(OrderRoutes));
